<template>
  <div class="sale-after-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/sallData' }">销售数据</el-breadcrumb-item>
      <el-breadcrumb-item>售后单详情</el-breadcrumb-item>
    </el-breadcrumb>
     <div class="sale-info">
        <p class="sale-info-title">售后信息</p>
        <div class="sale-info-content">
          <div class="sale-info-item">
            <p>AD单号：<span>{{orderdetail.adId}}</span></p>
            <p>售后服务单号：<span>{{orderdetail.serviceNumber}}</span></p>
            <p>售后服务：<span>{{orderdetail.asTypeStr}}</span></p>
            <p>退货类型：<span>{{orderdetail.asReturnTypeStr}}</span></p>
          </div>
          <div class="sale-info-item">
            <p>退款类型：<span>{{orderdetail.refundTypeStr}}</span></p>
            <p>售后类型：<span>{{orderdetail.applyReasonStr}}</span></p>
            <p>审核类型：<span>{{orderdetail.reviewReasonStr}}</span></p>
            <p>物流公司(代购上传)：<span>{{orderdetail.expressCompany}}</span></p>
          </div>
          <div class="sale-info-item">
            <p>物流单号(代购上传)：<span>{{orderdetail.expressNumber}}</span>&nbsp;&nbsp;<el-button
              v-if=" orderdetail.expressNumber "
              @click="onCopy"
              class="expressNumber"
              data-clipboard-action="copy"
              :data-clipboard-text="orderdetail.expressNumber"
              type="text"
              size="small">
              复制
            </el-button></p>
            <p>货款退款金额：<span>{{ (orderdetail.goodsFee / 100).toFixed(2) }}</span></p>
            <p>运费补偿金额：<span>{{ (orderdetail.freightCharge /100).toFixed(2) }}</span></p>
            <p>仅补偿金额：<span>{{ (orderdetail.flawCompensate/ 100).toFixed(2)}}</span></p>
          </div>
          <div class="sale-info-item">
            <p>申请时间：<span>{{orderdetail.createdTimeStr}}</span></p>
          </div>
          <div class="sale-reason-desc">
            <div class="text-desc">
              <p class="text-desc-title">售后原因</p>
              <div class="text-desc-content">{{orderdetail.applyRemark}}</div>
            </div>
            <div class="pic-info">
              <p class="pic-title">上传图片</p>
              <div class="pic-list">
                <span v-for="(url, idx) of orderdetail.applyUrls || []" :key="idx">
                  <img :src = "url"/>
                </span>
              </div>
            </div>
          </div>
        </div>
     </div>
     <div class="sale-info">
        <p class="sale-info-title">商品信息</p>
        <div class="sale-info-content">
          <div class="sale-info-item">
            <p>品牌名称：<span>{{ orderdetail.brand }}</span></p>
            <p class="flex4">商品名称：<span>{{ orderdetail.merName }}</span></p>
            <p>尺码：<span>{{ orderdetail.size }}</span></p>
          </div>
          <div class="sale-info-item">
            <p>颜色：<span>{{ orderdetail.color}}</span></p>
            <p class="flex4">商品款号：<span>{{ orderdetail.merStyleNo }}</span></p>
            <p>商品条码：<span>{{ orderdetail.barCode }}</span></p>
          </div>
          <!-- <div class="sale-info-item">
            <p>商品数量：<span>{{ orderdetail.barCode }}</span></p>
          </div> -->
          <div class="sale-reason-desc">
            <div class="text-desc">
              <p class="text-desc-title">档期详情</p>
              <div class="text-desc-content">{{ orderdetail.activityName }} {{  orderdetail.activityBeginTimeStr }} {{  orderdetail.activityEndTimeStr }}</div>
            </div>
            <div class="pic-info">
              <p class="pic-title">商品图片</p>
              <div class="pic-list">
                  <span v-for="(url, idx) in orderdetail.merchandiseUrls || []" :key="idx">
                    <img :src = "url"/>
                  </span>
              </div>
            </div>
          </div>
        </div>
     </div>
     <div class="sale-info">
        <p class="sale-info-title">售后日志</p>
        <table-list :orders="orderdetail" :tabelHead="tabelHead" ></table-list>
     </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { mapGetters } from 'vuex'
import tableList from '@components/tableList'
export default {
  name: 'saleAfterDetail',
  components: {
    tableList
  },
  props: {

  },
  data () {
    return {
      tabelHead: [{
        label: '审核人',
        value: 'reviewer'
      }, {
        label: '审核时间',
        value: 'reviewTime'
      }, {
        label: '审核处理',
        value: 'reviewStatus'
      }, {
        label: '备注信息',
        value: 'reviewRemark'
      }]
    }
  },
  computed: {
    ...mapGetters({
      orderdetail: 'saleData/orderdetail'
    })
  },
  methods: {
    onCopy () {
      const clipboard = new Clipboard('.expressNumber')
      const _this = this
      clipboard.on('success', function () {
        _this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', function (e) {
        _this.$message.success('复制失败')
        clipboard.destroy()
      })
    }

  },
  mounted () {
    console.log('orderdetail.....', this.orderdetail)
  },
  async created () {
    const { dispatch } = this.$store
    const { path = '' } = this.$route
    const asOrderId = path.match(/\d/gi).join('')
    await dispatch('saleData/queryDetail', { asOrderId })
  }
}
</script>
<style scoped lang="scss">
  .sale-after-detail{
    width: 1180px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 100px;
     margin-top:24px;
    font-family:PingFang-SC-Medium,Ping;
    .el-breadcrumb__item{
      font-size: 16px;
      .el-breadcrumb__inner{
        &.is-link{
          color: #999999;
        }

      }
      .el-breadcrumb__inner{
        .el-icon-arrow-right{
          color: #F03946;
        }

      }
    }
    .sale-info{
      margin-top:32px;
      .sale-info-title{
        color: #393E4E;
        font-size:18px;
        text-align: left;
      }
      .sale-info-content{
        margin-top:32px;
        .sale-info-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom:10px;
          color: #8A8C93;
          font-weight:500;
          .flex4{
            flex: 4;
          }
          p{
            flex: 1;
            text-align: left;
            span{
              color: #4A4A4A;
            }
            &:nth-child(1),&:nth-child(2),&:nth-child(3){
              min-width: 310px;
            }
            .el-button{
              padding: 0;
            }
          }
        }
        .sale-reason-desc{
          display: flex;
          justify-content: space-between;
          margin-top: 24px;
          .text-desc{
            margin-right: 80px;
            .text-desc-title{
              text-align: left;
              padding-bottom: 12px;
            }
            .text-desc-content{
              padding: 15px 16px 19px;
              background-color: #F5F5F5;
              text-align: left;
            }
          }
          .pic-info{
            .pic-title{
              text-align: left;
            }
            .pic-list{
              display: flex;
              margin-top:12px;
              span{
                width: 100px;
                height: 100px;
                margin-left: 10px;
                img{
                  width: 100%;
                  height: 100%;;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
